import React, { useState } from 'react'
import { moreProjects, myProjects } from '../Configurations';
import Icon from './Icons/Icon';

const Projects = () => {

    const [isOpen, setIsOpen] = useState(false)

    return (
        <section className='comp-section' id='projects'>
            <div className='top-title'><span>Projects</span></div>
            <div className='project-section'>
                {
                    myProjects.map((val, i) => {
                        return (
                        <div key={`${val.title} - ${i}`} className='project-wrapper'>
                            <div>
                                <a href={val.links[0].url} rel="noreferrer" target='_blank' >
                                    <h2>{val.title}</h2>
                                </a>
                                <p>{val.description}</p>
                                <ul className='post-tags'>
                                    {
                                        val.tags.map((tVal, tI) => {
                                            return <li key={tI}>{tVal}</li>
                                        })
                                    }
                                </ul>
                                <div className='flex f-wrap' style={{gap:'1em'}}>
                                    {
                                        val.links.map((lVal, lI) => {
                                            return (
                                                <a key={lI} href={lVal.url} rel="noreferrer" target='_blank' >
                                                    <Icon name={lVal.title} />
                                                </a>
                                            ) 
                                        })
                                    }
                                </div>
                            </div>
                            {
                                val.picture && 
                                <a href={val.links[0].url} rel="noreferrer" target='_blank' >
                                    <img className='project-image' src={val.picture} alt={val.title} />
                                </a>
                            }
                            
                        </div>
                        )
                    })
                }
                <div onClick={() => setIsOpen(!isOpen)} style={{fontSize:"2rem"}}
                className={`c-color pointer plus-sign${isOpen ? ' open' : ''}`}>{isOpen ? 'Hide' : 'Show'} more projects ({moreProjects.length}) </div>

                {
                isOpen &&
                <section className='more-list'>
                    {
                        moreProjects.map((proj, i) => {
                            return(
                            <div className='more-list-elem' key={i}>
                                <div onClick={() => window.open(proj.links[1].url, '_blank')} >{proj.title}</div>
                                <div className='flex f-wrap' style={{gap:'1em'}}>
                                    {
                                        proj.links.map((lVal, lI) => {
                                            return (
                                                <a key={lI} href={lVal.url} rel="noreferrer" target='_blank' >
                                                    <Icon name={lVal.title} />
                                                </a>
                                            ) 
                                        })
                                    }
                                </div>
                            </div>
                            )
                        })
                    }
                </section>
                }

                <div>For even more projects please visit <a rel="noreferrer" href='https://github.com/alexgarbacea?tab=repositories' target='_blank'
                className='c-color c-font'>github.com/alexgarbacea</a></div>

                <div>Check out my games on <a rel="noreferrer" href='https://play.google.com/store/apps/dev?id=5777513003852495025' target='_blank'
                className='c-color c-font'>GooglePlay</a></div>
            </div>
        </section>
    )
}

export default Projects